import React, { useState } from "react";
import "../style.css";

const SharingButtonWithPopup = ({ shareUrl, postName }) => {
  const [shareModalVisible, setShareModalVisible] = useState(false);

  const handleShare = () => {
    if (navigator.share) {
      navigator
        .share({
          title: postName,
          text: `Check out this amazing post: ${postName}`,
          url: shareUrl,
        })
        .then(() => console.log("Post shared successfully"))
        .catch((error) => console.error("Error sharing:", error));
    } else {
      setShareModalVisible(true);
    }
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(shareUrl).then(() => {
      alert("Link copied to clipboard!");
    });
  };

  return (
    <div className="sharing-button-container">
      {/* Share Button */}
      <button className="sharing-button" aria-label="Share" onClick={handleShare}>
        <svg
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="sharing-icon"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.803 5.33333C13.803 3.49238 15.3022 2 17.1515 2C19.0008 2 20.5 3.49238 20.5 5.33333C20.5 7.17428 19.0008 8.66667 17.1515 8.66667C16.2177 8.66667 15.3738 8.28596 14.7671 7.67347L10.1317 10.8295C10.1745 11.0425 10.197 11.2625 10.197 11.4872C10.197 11.9322 10.109 12.3576 9.94959 12.7464L15.0323 16.0858C15.6092 15.6161 16.3473 15.3333 17.1515 15.3333C19.0008 15.3333 20.5 16.8257 20.5 18.6667C20.5 20.5076 19.0008 22 17.1515 22C15.3022 22 13.803 20.5076 13.803 18.6667C13.803 18.1845 13.9062 17.7255 14.0917 17.3111L9.05007 13.9987C8.46196 14.5098 7.6916 14.8205 6.84848 14.8205C4.99917 14.8205 3.5 13.3281 3.5 11.4872C3.5 9.64623 4.99917 8.15385 6.84848 8.15385C7.9119 8.15385 8.85853 8.64725 9.47145 9.41518L13.9639 6.35642C13.8594 6.03359 13.803 5.6896 13.803 5.33333Z"
            fill="#007bff"
          />
        </svg>
      </button>

      {/* Popup */}
      {shareModalVisible && (
        <div className="share-modal">
          <div className="share-modal-content">
            <h4>Share This Post</h4>
            <p>Copy the link below to share this post:</p>
            <input type="text" value={shareUrl} readOnly className="share-link" />
            <button className="copy-link-button" onClick={handleCopyLink}>
              Copy Link
            </button>
            <button
              className="close-share-modal"
              onClick={() => setShareModalVisible(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SharingButtonWithPopup;
